/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

function hasCapability(glassContext) {
	const {
		capabilities = []
	} = glassContext.services.userProfile;

	return capabilities.indexOf('canUseExploration') !== -1;
}

export {
	hasCapability
};



// WEBPACK FOOTER //
// ./src/js/util/CapabilityUtil.js